module.exports = __webpack_public_path__ + "static/media/icon.46c7ca6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Icons/assets/facebook-container/icon.svg
// module id = ./src/assets/Mozilla/DesignTokens/Icons/assets/facebook-container/icon.svg
// module chunks = 0